import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/location-icon.png'
import _imports_1 from '../../assets/icons/red-packet-icon2.png'
import _imports_2 from '@/assets/images/default-logo.jpg'
import _imports_3 from '../../assets/icons/right-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-c2e18786"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dealer-list-wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "result-tip" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前无符合条件的经销商", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请尝试看看其他品牌", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "dealer-list" }
const _hoisted_8 = {
  key: 0,
  class: "discount-tag"
}
const _hoisted_9 = { class: "conrner-discount" }
const _hoisted_10 = { class: "l-con" }
const _hoisted_11 = { class: "info" }
const _hoisted_12 = { class: "dealer-short-name" }
const _hoisted_13 = { class: "area-name" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_15 = { class: "tags" }
const _hoisted_16 = { class: "main-brand" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_19 = { class: "r-con" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  alt: ""
}
const _hoisted_22 = {
  key: 1,
  src: _imports_2,
  alt: ""
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "txt",
  style: { color: '#656565' }
}, "加载中...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_btn = _resolveComponent("custom-btn")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, _hoisted_6, 512), [
        [_vShow, _ctx.noResult]
      ]),
      _createElementVNode("ul", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "item",
            key: index
          }, [
            (item.discountPrice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_custom_btn, {
                    btnType: 'right-top-tag',
                    bgColor: _ctx.activityInfo.subjectRgb
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, " 优惠高达" + _toDisplayString(item.discountPrice) + "万 ", 1)
                    ]),
                    _: 2
                  }, 1032, ["bgColor"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(item.dealerShortName), 1),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("span", null, _toDisplayString(item.areaName), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_custom_btn, {
                  btnType: 'tag3',
                  bgColor: _ctx.activityInfo.assistRgb,
                  color: '#ffffff',
                  class: "tag vip"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.vip) + "商家", 1)
                  ]),
                  _: 2
                }, 1032, ["bgColor"]),
                _createVNode(_component_custom_btn, {
                  btnType: 'tag3',
                  bgColor: _ctx.activityInfo.assistRgb,
                  color: '#ffffff',
                  class: "tag name-list-range"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.nameListRange), 1)
                  ]),
                  _: 2
                }, 1032, ["bgColor"]),
                (item.giftPrice)
                  ? (_openBlock(), _createBlock(_component_custom_btn, {
                      key: 0,
                      btnType: 'tag3',
                      bgColor: _ctx.activityInfo.assistRgb,
                      color: '#ffffff',
                      class: "tag gift-price"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.giftPrice), 1)
                      ]),
                      _: 2
                    }, 1032, ["bgColor"]))
                  : _createCommentVNode("", true),
                (item.replaceMaxDiscount)
                  ? (_openBlock(), _createBlock(_component_custom_btn, {
                      key: 1,
                      btnType: 'tag3',
                      bgColor: _ctx.activityInfo.assistRgb,
                      color: '#ffffff',
                      class: "tag replace-max-discount"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.replaceMaxDiscount), 1)
                      ]),
                      _: 2
                    }, 1032, ["bgColor"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, "主营品牌：" + _toDisplayString(item.businessBrand), 1),
              (item.dealerNewsTitle)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "dealer-news-title",
                    onClick: ($event: any) => (_ctx.jumpToNewsPage(item))
                  }, [
                    _hoisted_18,
                    _createElementVNode("span", {
                      style: _normalizeStyle({ color: _ctx.activityInfo.subjectRgb })
                    }, _toDisplayString(item.dealerNewsTitle) + ">", 5)
                  ], 8, _hoisted_17))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: "dealer-logo",
                onClick: ($event: any) => (_ctx.jumpToDealerShopPage(item))
              }, [
                (item.logoUrl)
                  ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_21, null, 512)), [
                      [_directive_lazy, item.logoUrl]
                    ])
                  : (_openBlock(), _createElementBlock("img", _hoisted_22))
              ], 8, _hoisted_20),
              _createElementVNode("div", {
                class: "right-icon-wrapper",
                style: _normalizeStyle({ 'background-color': _ctx.activityInfo.subjectRgb })
              }, [
                _createElementVNode("div", {
                  class: "right-icon",
                  onClick: ($event: any) => (_ctx.jumpToDealerShopPage(item))
                }, _hoisted_25, 8, _hoisted_23)
              ], 4)
            ])
          ]))
        }), 128))
      ])
    ]),
    _withDirectives(_createVNode(_component_van_loading, {
      class: "loading-box",
      size: "50px",
      type: "spinner",
      vertical: "",
      color: _ctx.activityInfo.subjectRgb
    }, {
      default: _withCtx(() => [
        _hoisted_26
      ]),
      _: 1
    }, 8, ["color"]), [
      [_vShow, _ctx.isShowLoading]
    ])
  ]))
}